import React from 'react';

export const Georegion = (props) => {
  return (
    <div className="container p-0 mt-4">
      {props?.georegion && (
        <label className="h5 mb-2">Georegion:</label>
      )}
      <div className="form-group d-flex flex-wrap align-items-stretch">
        {props?.georegion &&
          props?.georegion &&
          React.Children.toArray(
            props?.georegion?.map((geoReg) => (
              <>
                <div
                  className={`button-belair col-6 mb-0 mt-0 ${
                    // eslint-disable-next-line eqeqeq
                    props?.getgeoregion == geoReg?.id ? 'blend' : ''
                  }`}
                  onClick={props?.handleGeoRegion}
                  data-georegion={geoReg?.id}
                >
                  {geoReg?.text}
                </div>
              </>
            )),
          )}
      </div>
    </div>
  );
};
